import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { startOfDay } from 'date-fns';
import { filter } from 'rxjs/operators';
import { Address, GanttTask, Profile, WorkOrder } from 'src/app/data-models/models';
import { ImageHandlerService } from 'src/app/services/vendor/image-handler.service';
import { keyTypesEnum, NavigatorService, workOrderStatusTypes } from 'src/app/services/vendor/navigator.service';
import { WorkOrdersService } from 'src/app/services/vendor/work-orders.service';
import { VendorAddWorkOrderDialogComponent } from '../vendor-add-work-order-dialog/vendor-add-work-order-dialog.component';
import { VendorWorkAuditTrackerDialogComponent } from '../vendor-work-audit-tracker-dialog/vendor-work-audit-tracker-dialog.component';

import { Gantt } from './frappe-gantt/frappe_gantt'

export enum ganttViewTypes {
  FULL_VIEW = 0,
  DISCREET_VIEW = 1
}

type imgMap = {
  [key: string]: string;
};

@Component({
  selector: 'app-vendor-work-order-gantt',
  templateUrl: 'vendor-work-order-gantt.component.html',
  styleUrls: ['vendor-work-order-gantt.component.scss']
})
export class VendorWorkOrderGanttComponent implements OnInit {
  viewType: any = ganttViewTypes;
  keytypes: any = keyTypesEnum;
  workOrderStatusTypes: any = workOrderStatusTypes;
  startDate: Date = new Date();
  endDate: Date = new Date();

  @Input('workOrders') workOrders: Array<WorkOrder> = [];
  @Input('employees') employees: Array<Profile> = [];
  @Input("viewMode") viewMode: number = this.viewType.FULL_VIEW;
  @Input("expandCollapse") expand: boolean = true;
  @Input("actionMenu") actionMenu: boolean = true;
  @Input("expansionMenu") expansionMenu: boolean = true;
  @Input("incomingAddress") incomingAddress: Address;


  @Output('ganttDataUpdated') ganttDataUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('ganttViewModeUpdated') ganttViewModeUpdated: EventEmitter<number> = new EventEmitter<number>();
  @Output('ganttExpandCollapseUpdated') ganttExpandCollapseUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('refresh') refresh: EventEmitter<boolean> = new EventEmitter<null>();

  public addWorkOrderDialogRef: MatDialogRef<VendorAddWorkOrderDialogComponent>;
  private workAuditTrackerDialogRef: MatDialogRef<VendorWorkAuditTrackerDialogComponent>;

  public ganttChart: any;

  public employeeGanttData: any = [];
  public profileImgs: imgMap = { };

  // public tasks: Array<GanttTask> = [
  //   {
  //     start: this.startDate,
  //     end: this.endDate,
  //     name: 'Redesign website',
  //     id: "Task 0",
  //     sub_tasks: [
  //       "Task 1"
  //     ],
  //     isCollapsed: false,
  //     progress: 20
  //   },
  //   {
  //     start: this.startDate,
  //     end: this.endDate,
  //     name: 'Write new content',
  //     id: "Task 1",
  //     progress: 5,
  //     sub_tasks: [
  //       "Task 2"
  //     ],
  //     isCollapsed: false,
  //     dependencies: 'Task 0'
  //   },
  //   {
  //     start: this.startDate,
  //     end: this.endDate,
  //     name: 'Apply new styles',
  //     id: "Task 2",
  //     progress: 10,
  //     sub_tasks: [
  //       "Task 3",
  //       "Task 4"
  //     ],
  //     isCollapsed: false,
  //     dependencies: 'Task 1'
  //   },
  //   {
  //     start: this.startDate,
  //     end: this.endDate,
  //     name: 'Review',
  //     id: "Task 3",
  //     progress: 5,
  //     isCollapsed: false,
  //     dependencies: 'Task 2'
  //   },
  //   {
  //     start: this.startDate,
  //     end: this.endDate,
  //     name: 'Deploy',
  //     id: "Task 4",
  //     progress: 0,
  //     sub_tasks: [
  //       "Task 5"
  //     ],
  //     isCollapsed: false,
  //     dependencies: 'Task 2'
  //   },
  //   {
  //     start: this.startDate,
  //     end: this.endDate,
  //     name: 'Go Live!',
  //     id: "Task 5",
  //     isCollapsed: false,
  //     progress: 0,
  //     dependencies: 'Task 4',
  //     custom_class: 'bar-milestone'
  //   },
  //   {
  //     start: this.startDate,
  //     end: this.endDate,
  //     name: 'Long term task',
  //     id: "Task 6",
  //     isCollapsed: false,
  //     progress: 0
  //   }
  // ];

  public tasks: Array<GanttTask> = [];
  public wrapper_container: string = "#workOrderGantt";
  public isLoading: boolean = true;
  public isAddingWorkOrder: boolean = false;
  public isWorkOrderOpen: boolean = false;
  private savedScrollLeft: number = 0;
  private hasScrolledInitially: boolean = false;

  constructor(
    public navigatorService: NavigatorService, 
    private imageHandler: ImageHandlerService, 
    private workOrdersService: WorkOrdersService,
    public dialog: MatDialog

  ) { }

  async ngOnInit() {
    this.initializeGanttEmployees();

    try {
      await this.convertWorkOrders().then( data => {
        this.initializeGanttChart();
      });
    } catch (error) {
    console.log("Gantt Chart WO Conversion Error: ", error);
  }

    this.isLoading = false;
  }


  ngOnChanges(changes: SimpleChanges) {
    const ganttElement = document.getElementById('workOrderGantt');
    if (ganttElement) {

      this.savedScrollLeft = ganttElement.scrollLeft;
     
    }
  
    console.log("Gantt Data Change");
    this.resetGanttChart();
  }

  private initialLoadLeft(): void {

    requestAnimationFrame(() => {
      const ganttElement = document.getElementById('workOrderGantt');
      if (!ganttElement || this.hasScrolledInitially) return;
    
      // Calculate scroll to 4 hours before now
      const now = new Date();
      const scrollTarget = new Date(now.getTime() - 1 * 60 * 60 * 1000); // now minus 4 hours
      const diffMinutes = (scrollTarget.getTime() - this.ganttChart.gantt_start.getTime()) / 60000;
    
      const scrollLeft = (diffMinutes / 60) * this.ganttChart.options.column_width;
    
      ganttElement.scrollLeft = 200;
    
      this.hasScrolledInitially = true;
    });

  }

  private async resetGanttChart(): Promise<void> {
    this.isLoading = true;

    this.initializeGanttEmployees();
    this.initializeProfileImgs();
    await this.convertWorkOrders().then( (tasks: Array<GanttTask>) => {

      if (this.ganttChart) {
        this.ganttChart.destroy();
      }

      this.tasks = [];

      if(tasks.length > 0) {
        this.tasks = tasks;
      }

      this.initializeGanttChart();
    });

    // 🔁 Restore scroll after rendering
    setTimeout(() => {
      const ganttContainer = document.getElementById('workOrderGantt');
      requestAnimationFrame(() => {
        if (ganttContainer) ganttContainer.scrollLeft = this.savedScrollLeft;
      });
    }, 0);
    

    this.isLoading = false;
  }

  initializeGanttEmployees(): void {
    this.employeeGanttData = [];

    for(let employee of this.employees) {

      this.employeeGanttData.push({
        employeeId: employee.id,
        height: "77px"
      });

    }

  }

  private async initializeProfileImgs(): Promise<void> {

    if (this.employees?.length == 0)
      return;

    for(let employee of this.employees) {
      const image: string = await this.imageHandler.getPresignedURL(employee?.image);
      this.profileImgs[employee?.id] = image;
    }

  }

  public onImgError(employeeId: string): void {
    this.profileImgs[employeeId] = 'assets/images/others/user.jpg';
  }

  async convertWorkOrders(): Promise<Array<GanttTask>> {
    let tasks: Array<GanttTask> = [];

    console.log("Gantt Work Orders: ", this.workOrders);

    if(this.workOrders != undefined && this.workOrders != null && this.workOrders.length > 0) {

      for(let workOrder of this.workOrders) {

        await this.convertWorkOrder(workOrder).then( (ganttTasks: Array<GanttTask>) => {
          
          for(let ganttTask of ganttTasks) {
            tasks.push(ganttTask);
          }

        });
  
      }

    }

    console.log("Generated Gantt Tasks: ", tasks);

    return tasks;
  }

  async convertWorkOrder(workOrder: WorkOrder, parentId?: string): Promise<Array<GanttTask>> {
    let tasks: Array<GanttTask> = [];
    let task: GanttTask = null;
    let statusIcon: string = "";
    let status: string = "";

    if(workOrder?.dateScheduled == undefined || workOrder?.dateScheduled == null) {
      return tasks;
    }

    switch(workOrder?.status) {

        case this.workOrderStatusTypes.STANDBY:
          statusIcon = 'sensor_occupied';
          status = "standby";
          break;

        case this.workOrderStatusTypes.HOLD:
          status = "hold";
          statusIcon = 'hourglass_bottom';
          break;

        case this.workOrderStatusTypes.ENROUTE:
          status = "enroute";
          statusIcon = 'local_shipping';
          break;

        case this.workOrderStatusTypes.STARTED:
          status = "started";
          statusIcon = 'construction';
          break;

        case this.workOrderStatusTypes.WORKING:
          status = "working";
          statusIcon = 'construction';
          break;

        case this.workOrderStatusTypes.COMPLETED:
          status = "completed";
          statusIcon = 'published_with_changes';
          break;

        case this.workOrderStatusTypes.CLOSED:
          status = "closed";
          statusIcon = 'task_alt';
          break;

        case this.workOrderStatusTypes.CANCELED:
          status = "canceled";
          statusIcon = 'free_cancellation';
          break;

        case this.workOrderStatusTypes.SCHEDULED:
          status = "scheduled";
          statusIcon = 'event_available';
          break;

        default:
          break;
    }

    if(workOrder?.assignedStaff?.length > 0 || workOrder?.assignedStaff?.length > 0) {

      for(let staff of workOrder?.assignedStaff) {

        task = {
          start: new Date(workOrder?.dateScheduled),
          end: this.calculateEndDate(new Date(workOrder?.dateScheduled), workOrder?.timeStretch),
          name: workOrder?.description,
          task_id: this.navigatorService.generateKey(this.keytypes.WORK_ORDER_ID),
          id: workOrder.workOrderId,
          employee_id: staff,
          status: status,
          status_icon: statusIcon,
          // sub_tasks: [],
          progress: 50,
          custom_class: 'ganttWorkOrderTask'
        };

        tasks.push(task);
      }

    }

    // if(workOrder.parent_work_order != undefined && workOrder.parent_work_order != null) {
    //   let parentIndex: number = this.workOrders.findIndex( (wo: WorkOrder) => { return wo.workOrderId == workOrder.parent_work_order} );

    //   if(parentIndex > -1) {
    //     task.dependencies = workOrder.parent_work_order;
    //     task.isCollapsed = false;
    //   }
      
    // }

    if(workOrder?.foreign_work_orders != undefined && workOrder?.foreign_work_orders?.length > 0) {
      task.sub_tasks = workOrder?.foreign_work_orders;
      

      await this.getChildWorkOrdersAsTasks(workOrder).then( (ganttTasks: Array<GanttTask>) => {
        
        for(let ganttTask of ganttTasks) {
          ganttTask.dependencies = task.task_id;
          ganttTask.isCollapsed = false;

          tasks.push(ganttTask);
        }

      });
      
    } 

    return tasks;
  }

  async getChildWorkOrdersAsTasks(workOrder: WorkOrder): Promise<Array<GanttTask>> {
    let tasks: Array<GanttTask> = [];

    if(workOrder?.foreign_work_orders == undefined) {
      return;
    }

    for(let childID of workOrder?.foreign_work_orders) {

      await this.navigatorService.getWorkOrder(childID).then( (childWO: WorkOrder) => {

        if(childWO != undefined && childWO != null) {

          this.convertWorkOrder(childWO).then( (ganttTasks: Array<GanttTask>) => {
            
            for(let ganttTask of ganttTasks) {
              ganttTask.isAttached = true;
              tasks.push(ganttTask);
            }

          });
          
        }

      });

    }

    return tasks;
  }

  calculateEndDate(startDate: Date, minutes: number): Date {
    let endDate: Date = new Date(startDate);

    endDate.setMinutes(endDate.getMinutes() + minutes);

    return endDate;
  }

  initializeGanttChart(): void {
    let self: any = this;
    this.endDate.setHours(this.startDate.getHours() + 2);
    
    // if(this.tasks.length > 0) {
    this.ganttChart = new Gantt("#gantt", this.wrapper_container, this.tasks, {

      on_click: function (taskEvent) {
        console.log("Gantt Click: ", taskEvent);
      },

      on_dblclick: function (taskEvent) {
        console.log("Gantt dblclick: ", taskEvent);
      },

      on_date_change: async function(task, start: Date, end: Date) {
        let changeWorkOrder: WorkOrder = self.workOrders.find( (workOrder: WorkOrder) => { return workOrder.workOrderId == task.id });

        let startMili: number = start.getTime();
        let endMili: number = end.getTime();

        let diffMili: number = endMili - startMili;
        let diffMinutes: number = Math.round( ( (diffMili / 1000) / 60) );

        if(changeWorkOrder != undefined && changeWorkOrder != null) {

          self.navigatorService.getWorkOrder(changeWorkOrder.workOrderId).then( async (workOrder: WorkOrder) => {

            if(workOrder != undefined && workOrder != null) {

              workOrder.dateScheduled = start;
              workOrder.timeStretch = diffMinutes;
              workOrder.endDate = new Date(start.getTime() + diffMinutes * 60 * 1000);

              changeWorkOrder = workOrder;

              const isSuccessful: boolean = await self.workOrdersService.updateWorkOrder(
                workOrder?.workOrderId, 
                {
                  dateScheduled: workOrder.dateScheduled,
                  endDate: workOrder.endDate,
                  timeStretch: workOrder?.timeStretch
                }
              );

              self.ganttDataUpdated.emit(isSuccessful);

            }

          });

        }

        console.log("Gantt Date Change: ", task);
      },

      on_employee_change: async function(task, assigned_employee_index, updated_employee_index) {
        console.log("Gantt Employee Change: ", task);
        let employee = null;
        let prevEmployee = null;

        if(updated_employee_index >= 0 && assigned_employee_index >= 0) {
          employee = self.employees[updated_employee_index];
          prevEmployee = self.employees[assigned_employee_index];
        }

        // If the current and previous employee aren't located then do nothing
        if(employee == null || prevEmployee == null) return;


        let changeWorkOrder: WorkOrder = self.workOrders.find( (workOrder: WorkOrder) => { return workOrder.workOrderId == task.id });

        if(changeWorkOrder != undefined && changeWorkOrder != null) {

          self.navigatorService.getWorkOrder(changeWorkOrder.workOrderId).then( async (workOrder: WorkOrder) => {

            if(workOrder != undefined && workOrder != null) {

              let prevAssignedEmployeeIndex: number = workOrder.assignedStaff.findIndex((id: string) => { return id == prevEmployee.id });

              if(prevAssignedEmployeeIndex > -1) {
                workOrder.assignedStaff.splice(prevAssignedEmployeeIndex, 1);
              }

              if(employee != null) {
                workOrder.assignedStaff.push(employee.id);
              }

              workOrder.technicianId = null;

              changeWorkOrder = workOrder;

              const isSuccessful: boolean = await self.workOrdersService.updateWorkOrder(
                workOrder?.workOrderId, 
                {
                  assignedStaff: workOrder.assignedStaff,
                  technicianId: workOrder.technicianId
                }
              );

              self.ganttDataUpdated.emit(isSuccessful);
            }

          });

        }

        console.log("Gantt Change Employee", employee);
      },

      on_collapse_task: function(task, deepest_layer) {
        let employeeIndex: number = self.employeeGanttData.findIndex( employee => { return employee.employeeId == task.employee_id });

        if(employeeIndex > -1) {
          let layerCalculation: number = deepest_layer * 77;
          self.employeeGanttData[employeeIndex].height = (77 + layerCalculation) + "px";
        }

        console.log("Gantt Collapse Task: ", deepest_layer);
      },

      on_expand_task: function(task, deepest_layer) {
        let employeeIndex: number = self.employeeGanttData.findIndex( employee => { return employee.employeeId == task.employee_id });

        if(employeeIndex > -1) {
          let layerCalculation: number = deepest_layer * 77;
          self.employeeGanttData[employeeIndex].height = (77 + layerCalculation) + "px";
        }

        console.log("Gantt Expand Task: ", deepest_layer);
      },

      on_progress_change: function(task, progress) {
        console.log(task, progress);
      },

      on_view_change: function(mode) {
        console.log(mode);
      },

      on_open_work_order: async function(task: GanttTask) {

        self.openWorkOrderDialog(task?.id);

      },

      on_add_work_order: function(employeeIndex: number, startDate: Date, endDate: Date) {

        const employee = self.employees[employeeIndex];

        if (!self.isAddingWorkOrder)
          self.openAddWorkOrderDialog(employee?.id, startDate, endDate);

      },

      employees: this.employees,
      view_mode: 'Hour',
      language: 'en'
    });
    
    console.log("Gantt Chart: ", this.ganttChart);

    this.ganttChart.refresh(this.tasks);

    // Scroll only once on initial load (now minus 4 hours)
    // requestAnimationFrame(() => {
    //   const ganttElement = document.getElementById('workOrderGantt');
    //   if (!ganttElement) return;

    //   const now = new Date();
    //   now.setHours(now.getHours() - 1); // Scroll to 4 hours before now

    //   const diffMinutes = (now.getTime() - this.ganttChart.gantt_start.getTime()) / 60000;
    //   const scrollLeft = (diffMinutes / 60) * this.ganttChart.options.column_width;

    //   ganttElement.scrollLeft = Math.max(scrollLeft, 0);
    // });

    // requestAnimationFrame(() => {
    //   const ganttElement = document.getElementById('workOrderGantt');
    //   if (ganttElement) {
    //     ganttElement.scrollLeft = this.savedScrollLeft;
    //   }
    // });
  }

  public updateGanttViewMode(viewMode: number): void {
    this.viewMode = viewMode;

    this.ganttViewModeUpdated.emit(this.viewMode);
  }

  public updateGanttExpandCollapse(expand: boolean): void {
    this.expand = expand;

    let gantt_element = document.querySelector(this.wrapper_container);
    gantt_element.scrollTop = 0;

    this.ganttExpandCollapseUpdated.emit(this.expand);
  }

  private eventFire(el, etype) {

    if(el == undefined && el == null) {
      return;
    }

    if (el.fireEvent) {
      el.fireEvent('on' + etype);
    } else {
      var evObj = document.createEvent('Events');
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  }


  // public openAddWorkOrderDialog(employeeId: string, startDate: Date, endDate: Date) {
  //   this.isAddingWorkOrder = true;

  //   this.addWorkOrderDialogRef = this.dialog.open(
  //     VendorAddWorkOrderDialogComponent,
  //     {
  //       data: {
  //         date: startDate,
  //         endDate: endDate,
  //         assignedId: employeeId,
  //         address: this.incomingAddress
  //       }
  //     }
  //   );

  //   this.addWorkOrderDialogRef.afterClosed().pipe(
  //     filter(data => data)
  //   ).subscribe(async data => {

  //     if(data.isCompleted) {
  //       console.log("Work Order Completed");

  //       await this.convertWorkOrder(data?.workOrderData).then((ganttTasks) => {
  //         for (let ganttTask of ganttTasks) {
  //           this.tasks.push(ganttTask);
  //         }
        
  //         this.ganttChart.refresh(this.tasks);
  //       });
        

  //       // this.workOrders.push(data.workOrderData);
  //       // this.convertWorkOrder
  //       // this.navigatorService.updateWorkOrder(data.workOrderData);

  //     }

  //     this.isAddingWorkOrder = false;

  //   });

  // }

  public openAddWorkOrderDialog(employeeId: string, startDate: Date, endDate: Date) {
    const ganttContainer = document.getElementById('workOrderGantt');
    const savedScrollLeft = ganttContainer?.scrollLeft ?? 0;

    this.savedScrollLeft = ganttContainer?.scrollLeft ?? 0;
  
    this.isAddingWorkOrder = true;
  
    this.addWorkOrderDialogRef = this.dialog.open(
      VendorAddWorkOrderDialogComponent,
      {
        data: {
          date: startDate,
          endDate: endDate,
          assignedId: employeeId,
          address: this.incomingAddress
        }
      }
    );
  
    this.addWorkOrderDialogRef.afterClosed().pipe(
      filter(data => data)
    ).subscribe(async data => {
  
      if (data.isCompleted) {
        this.workOrdersService.addWorkOrder(data?.workOrderData);
        
        await this.convertWorkOrder(data?.workOrderData).then((ganttTasks) => {
          for (let ganttTask of ganttTasks) {
            this.tasks.push(ganttTask);
          }
  
          this.ganttChart.refresh(this.tasks);
  
        });
      }

      // Restore scroll after rendering
      requestAnimationFrame(() => {
        if (ganttContainer) ganttContainer.scrollLeft = savedScrollLeft;
      });
  
      this.isAddingWorkOrder = false;
    });
  }
  

  public async openWorkOrderDialog(id: string): Promise<void> {

    const workOrder: WorkOrder = await this.workOrdersService.getWorkOrder(id);

    if(workOrder && !this.isWorkOrderOpen) {
      this.isWorkOrderOpen = true;

      this.workAuditTrackerDialogRef = this.dialog.open(
        VendorWorkAuditTrackerDialogComponent,
        { data: workOrder }
      );

      this.workAuditTrackerDialogRef.beforeClosed().subscribe(data => {
        console.log("Before Closed: ", data);
      });
      
      this.workAuditTrackerDialogRef.afterClosed().subscribe(data => {
        console.log("Dialog Closed: ", data);
        this.isWorkOrderOpen = false;

        this.refresh.emit();
      });

    }


  }

}